import axios from '@/libs/axios'

export default {
    namespaced: true,
    state: {
        products: [],
        pagination: null,
        isPending: false,
        search: {
            ty_product: {

            },
            product: {

            },
            brands: [],
            brand_ids: [],
            limit: 20,
            page: 1,
            status: [],
        },
    },
    getters: {
        _products(state) {
            return state.products
        },
        _pagination(state) {
            return state.pagination
        },
        _search(state) {
            return state.search
        },
        _isPending(state) {
            return state.isPending
        },
    },
    mutations: {
        setIsPending(state, isPending) {
            state.isPending = isPending
        },
        setProducts(state, products) {
            state.products = products
        },
        setSearch(state, search) {
            state.search = search
        },
        setPagination(state, data) {
            delete data.data
            state.pagination = data
        },
        setProductsPivotStatus(state, data) {
            data.forEach(item => {
                state.products.forEach(product => {
                    product.ty_all_products.forEach(tyProduct => {
                        if (tyProduct.id == item.ty_product_id) {
                            tyProduct.pivot.status = item.status
                        }
                    })
                })
            })
        },
        selectAll(state) {
            state.products.forEach(product => {
                product.ty_all_products.forEach(tyProduct => {
                    tyProduct.matching = true
                })
            })
        },
        deselectAll(state) {
            state.products.forEach(product => {
                product.ty_all_products.forEach(tyProduct => {
                    tyProduct.matching = false
                })
            })
        },
        matchingBarcode(state) {
            state.products.forEach(product => {
                product.ty_all_products.forEach(tyProduct => {
                    if (product.barcode === tyProduct.merchant_sku && tyProduct.pivot.status === 0) {
                        tyProduct.matching = true
                    }
                })
            })
        },
        matchingName(state) {
            state.products.forEach(product => {
                product.ty_all_products.forEach(tyProduct => {
                    if (product.name === tyProduct.product_name && tyProduct.pivot.status === 0) {
                        tyProduct.matching = true
                    }
                })
            })
        },
        selectPending(state) {
            state.products.forEach(product => {
                product.ty_all_products.forEach(tyProduct => {
                    if (tyProduct.pivot.status === 0) {
                        tyProduct.matching = true
                    }
                })
            })
        },
    },
    actions: {
        getAll(context) {
            context.commit('setProducts', [])
            return axios.get('/trendyol/product/match', {
                params: context.state.search,
            })
                .then(res => {
                    context.commit('setProducts', res.data.data)
                    context.commit('setPagination', res.data)
                    return true
                })
                .catch(() => false)
        },
        setProductsPivotStatusData(context, ids) {
            axios.post('/trendyol/product/set-pivot-all', { ids })
                .then(res => {
                    context.commit('setProductsPivotStatus', res.data.data)
                    return 1
                })
                .catch(() => {
                    alert('Statüleri değiştirme hatası')
                    return 1
                })
        },
    },
}
